import { Injectable } from '@angular/core';

import * as _ from 'lodash';


@Injectable()
export class LocalDBService {

    db: IDBDatabase;
    window: any = window;
    constructor(

    ) { }


    checkDB() {

        if (!this.db) {
            //Creating database if not exist
            return false;
        }
        return true;
    }

    createInspectionTable(callback) {

        const self = this;
        var request = indexedDB.open("wpe");
        request.onupgradeneeded = function () {
            // The database did not previously exist, so create object stores and indexes.
            self.db = request.result;
            var store = self.db.createObjectStore("InspectionData", { keyPath: "inspectionId" });
        };

        request.onsuccess = function () {
            self.db = request.result;
            callback()
        };
    }

    saveInspectionDetails(data) {
        if (this.checkDB()) {
            var tx = this.db.transaction("InspectionData", "readwrite");
            var store = tx.objectStore("InspectionData");

            store.add({ inspectionId: data.taskId, inspectionCount: data.taskCount, workOrderId: data.workOrderId, workOrderCount: data.workOrderCount, actionWorkOrderId: data.actionWorkOrderId, actionWorkOrderCount: data.actionWorkOrderCount });

            tx.onerror = function(ev) {
                console.log(ev);
            }
            tx.onabort = function(ev) {
                console.log(ev);
            }
            tx.oncomplete = function () {
                // All requests have succeeded and the transaction has committed.
            };
        }
    }

    updateInspectionDetails(data) {
        if (this.checkDB()) {

            var tx = this.db.transaction("InspectionData", "readwrite");
            var store = tx.objectStore("InspectionData");

            store.put(data);
            tx.onerror = function(ev) {
                console.log(ev);
            }
            tx.onabort = function(ev) {
                console.log(ev);
            }
            
            tx.oncomplete = function () {
                // All requests have succeeded and the transaction has committed.
            };
        }
    }

    getData(keys, callback) {
        if (this.checkDB()) {
            const self = this;

            var tx = this.db.transaction("InspectionData", "readwrite");
            var store: IDBObjectStore = tx.objectStore("InspectionData");

            var request = store.openCursor();
            request.onsuccess = function () {
                if (request.result && request.result.value) {

                    var matching = request.result.value;
                    if (matching !== undefined) {
                        // A match was found.
                        callback(matching);
                    }
                } else {
                    // No match was found.
                    self.createInspectionDataSetUp(function () {
                        self.getData(keys, callback)
                    })
                }
            };

        } else {
            // No match was found.
            const self = this;
            this.createInspectionDataSetUp(function () {
                self.getData(keys, callback)
            })
        }
    }

    deleteDB() {
        if (this.checkDB()) {
            indexedDB.deleteDatabase('wpe');
        }
    }

    createInspectionDataSetUp(onSuccess) {

        var self = this;
        this.createInspectionTable(function () {
            //Generating WorkOrderId and InspectionId

            var tx = self.db.transaction("InspectionData", "readwrite");
            var store = tx.objectStore("InspectionData");

            var request = store.openCursor();
            request.onsuccess = function () {
                if (request.result && request.result.value) {
                    //Data exists
                } else {
                    self.saveInspectionDetails({
                        taskId: (Date.now().toString(36).substr(2, 6) + Math.random().toString(36).substr(2, 3)),
                        taskCount: '001',
                        workOrderId: (Date.now().toString(36).substr(2, 6) + Math.random().toString(36).substr(2, 3)),
                        workOrderCount: '001',
                        actionWorkOrderId: (Date.now().toString(36).substr(2, 6) + Math.random().toString(36).substr(2, 3)),
                        actionWorkOrderCount: '001'
                    });
                }

                onSuccess();
            };

        });

    }
}


// WEBPACK FOOTER //
// ./src/app/local-db.service.ts